
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  private messageSource = new BehaviorSubject<string>('');
  currentMessage = this.messageSource.asObservable();

  constructor() {
    if (localStorage.getItem('notificationMessage') != null) {
      this.messageSource.next(localStorage.getItem('notificationMessage'));
    }
  }

  // This method allows other components to change the message
  changeMessage(message: string, soundAlert: boolean = false) {
    this.messageSource.next(message);

    if (soundAlert)
      this.playSound();
  }

  playSound(): void {
    const audio = new Audio();
    audio.src = 'assets/sounds/alert.mp3';
    audio.load();
    audio.play();
  }
}
